import { Component, Input, OnInit } from '@angular/core';
import { RealEstateService } from '../shared/real-estate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-real-estate-detail',
  templateUrl: './real-estate-detail.component.html',
  styleUrls: ['./real-estate-detail.component.css']
})
export class RealEstateDetailComponent implements OnInit {
  @Input()dealerListingData:any
  dealerHandle: any;
  details: any;
  handle: any;
  dealerData: any;
  @Input()media:any
  fullDealerListingData:any[]=[]
  listingImageData: any[]=[];
  mapUrl;
  
  constructor(private service: RealEstateService, private route: Router,private routeParam: ActivatedRoute,private sanitizer:DomSanitizer) { }

  ngOnInit(): void {
    
    this.handle = this.routeParam.snapshot.params['handle'];
   

    this.service.getRealestateDetails(this.handle).subscribe(res => {
      if(res) {
        this.dealerData = res.payload.J[0];
        this.fullDealerListingData = res.payload.J2;
        this.dealerListingData = res.payload.J2;
        this.media = res.payload.J1;
        this.listingImageData = res.payload.J3
        this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14723.58922800274!2d${this.dealerData?.Longitude}!3d${this.dealerData?.Latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1655377934896!5m2!1sen!2sin`)
       }
    })
    this.dealerHandle = this.routeParam.snapshot.params['id'];
    this.service.getRealestateListDetails(this.dealerHandle).subscribe(res => {
      this.details = res.payload.J[0];
      this.media = res.payload.J1;
    })
  }


  navigate(dealerHandle) {
    this.route.navigate([this.handle +'/detail/'+ dealerHandle]);
  }

  navigate2(dealerHandle) {
    this.route.navigate([this.handle +'/details/'+ dealerHandle]);
  }

  getImages(list){
    let image = this.listingImageData.filter(item=>item.ListingID==list.ListingID)
     if(image.length){
       return image
     }else{
       return []
     }
    }
 
   GetFloat(input: string): number {
     return parseFloat(input);
   }
 
   onMouseOver(infoWindow, event: MouseEvent) {
     infoWindow.open();
   }
 
   onMouseOut(infoWindow, event: MouseEvent) {
     infoWindow.close();
   }

}
